import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Event} from '../../model/strapi/event/event';
import {About} from '../../model/strapi/about/about';
import {environment} from '../../../environments/environment';
import {map} from 'rxjs';
import {BoardMember} from '../../model/strapi/boardmember/board-member';

@Injectable({
  providedIn: 'root'
})
export class StrapiService {

  constructor(private readonly http: HttpClient) { }

  getEvents() {
    const language = localStorage.getItem('lang') || navigator.language.slice(0,2);
    return this.http.get<Event[]>(environment.strapi + '/api/events?locale=' + language, {headers:{"Strapi-Response-Format":"v4"}})
      .pipe(map((result: any) => result.data));
  }

  getAnnouncements() {
    const language = localStorage.getItem('lang') || navigator.language.slice(0,2);
    return this.http.get<Event[]>(environment.strapi + '/api/announcements?populate=*&locale=' + language, {headers:{"Strapi-Response-Format":"v4"}})
      .pipe(map((result: any) => result.data));
  }

  getAbouts() {
    const language = localStorage.getItem('lang') || navigator.language.slice(0,2);
    return this.http.get<About[]>(environment.strapi + '/api/abouts?locale=' + language, {headers:{"Strapi-Response-Format":"v4"}})
      .pipe(map((result: any) => result.data));
  }

  getBoardMember() {
    const language = localStorage.getItem('lang') || navigator.language.slice(0,2);
    return this.http.get<BoardMember[]>(environment.strapi + '/api/boardmembers?sort=id&locale=' + language, {headers:{"Strapi-Response-Format":"v4"}})
      .pipe(map((result: any) => result.data));
  }

  getFaqHelp() {
    const language = localStorage.getItem('lang') || navigator.language.slice(0,2);
    return this.http.get<any[]>(environment.strapi + '/api/faq-helps?populate=*&sort=id&locale=' + language, {headers:{"Strapi-Response-Format":"v4"}})
      .pipe(map((result: any) => result.data));
  }

  getVideosHelp() {
    const language = localStorage.getItem('lang') || navigator.language.slice(0,2);
    return this.http.get<any[]>(environment.strapi + '/api/videos-helps?populate=*&sort=id&locale=' + language, {headers:{"Strapi-Response-Format":"v4"}})
      .pipe(map((result: any) => result.data));
  }

  getReleaseNotesHelp() {
    const language = localStorage.getItem('lang') || navigator.language.slice(0,2);
    return this.http.get<any[]>(environment.strapi + '/api/release-notes-helps?populate=*&locale=' + language, {headers:{"Strapi-Response-Format":"v4"}})
      .pipe(map((result: any) => result.data));
  }

}
